import { IOrderClause } from '@tableau/catalog-ui-temp';
import React from 'react';

import { Formatters } from '~src/codegen/Localize';

import { IScimConfiguration, ScimConfigurationsService } from '../../services/ScimConfigurationsService';
import { AuthenticationProviderType, IAuthenticationProvider, ISiteAuthenticationSettings, SiteAuthenticationSettingsService } from '../../services/SiteAuthenticationSettingsService';
import { ScimConfigurationsColumnKeys, ScimConfigurationsGrid } from './ScimConfigurationsGrid';

export type ScimConfigurationsDialogProps = {
    deleteScimIdpConfigurationId: (idToRemove: string) => void;
}

export type ScimConfigurationsDialogState = {
    allScimConfigurations: IScimConfiguration[];
    allSamlProviders: IAuthenticationProvider[];
    currentColumnSortOrder: IOrderClause;
}

export class ScimConfigurationsDialog extends React.Component<ScimConfigurationsDialogProps, ScimConfigurationsDialogState> {
    constructor(props: ScimConfigurationsDialogProps) {
        super(props);
        this.state = {
            allScimConfigurations: [],
            allSamlProviders: [],
            currentColumnSortOrder: {
                field: '',
                ascending: false
            },
        };
    }

    componentDidMount(): void {
        this.setUpInitialState();
    }



    private setUpInitialState(refresh: boolean = false) {

        SiteAuthenticationSettingsService.getSiteAuthenticationSettings(refresh)
            .then((siteAuthSettings: ISiteAuthenticationSettings) => {
                const samlProviders = siteAuthSettings?.allProviders?.filter((provider) => (provider.type === AuthenticationProviderType.saml));
                this.setState({ allSamlProviders: samlProviders });
            });
            ScimConfigurationsService.getAllScimConfigurations(refresh).then((scimConfigurations) => {
            const configurationsWithAuthConfigName = scimConfigurations.map((scimConfig) => {
                const matchingProvider = this.state.allSamlProviders?.find(
                    (provider) => provider.idpConfigurationId === scimConfig.idpConfigurationId
                );
                const formattedCreatedAt = scimConfig.createdAt ? Formatters.formatMediumDate(new Date(scimConfig.createdAt)):'';
                if (matchingProvider) {
                    return {
                        ...scimConfig,
                        authConfigName: matchingProvider.idpConfigurationName,
                        createdAt: formattedCreatedAt,
                    };
                }
                return {
                    ...scimConfig,
                    createdAt: formattedCreatedAt,
                };
            });
            this.setState({ allScimConfigurations: configurationsWithAuthConfigName });
        });
    }

    private changeColumnSort = (field: string) => {
        const currentColumnSortOrder = this.state.currentColumnSortOrder;
        const ascending = field === currentColumnSortOrder.field ? !currentColumnSortOrder.ascending : true;
        this.setState({ currentColumnSortOrder: { field, ascending } }, () => { this.sortDisplayData(field, ascending); });
    };

    // Method that is called when a user clicks on a sortable column
    private sortDisplayData = (field: string, ascending: boolean) => {
        let unsortedScimCofigurations = this.state.allScimConfigurations;
        if (field === ScimConfigurationsColumnKeys.ScimConfigurationName) {
            unsortedScimCofigurations.sort((config1, config2) => {
                return ascending ? config1.name.localeCompare(config2.name)
                    : config2.name.localeCompare(config1.name);
            });
        } else if (field === ScimConfigurationsColumnKeys.AuthenticationConfiguration) {
            unsortedScimCofigurations.sort((config1, config2) => {
                const config1Type = config1.authConfigName;
                const config2Type = config2.authConfigName;
                return ascending ? config1Type.localeCompare(config2Type) : config2Type.localeCompare(config1Type);
            });
        } else if (field === ScimConfigurationsColumnKeys.CreatedAt) {
            unsortedScimCofigurations.sort((config1, config2) => {
                const config1Date = config1.createdAt;
                const config2Date = config2.createdAt;
                return ascending ? config1Date.localeCompare(config2Date) : config2Date.localeCompare(config1Date);
            });
        }
        this.setState({ allScimConfigurations: unsortedScimCofigurations });
    };


    public render(): JSX.Element {
        return (
            <div>
                <ScimConfigurationsGrid
                    currentColumnSortOrder={this.state.currentColumnSortOrder}
                    handleColumnSortOrderChange={this.changeColumnSort}
                    displayData={this.state.allScimConfigurations}
                    refreshGrid={() => { this.setUpInitialState(); }}
                    deleteScimIdpConfigurationId={this.props.deleteScimIdpConfigurationId}                >
                </ScimConfigurationsGrid>
            </div>
        );
    }

}